// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #f3f5f8;
  --surface: #ffffff;
  --surface-2: #eef2f6;
  --text: #17202a;
  --muted: #667085;
  --line: #d9e0e8;
  --ok: #15803d;
  --ok-bg: #e8f7ef;
  --warn: #b45309;
  --warn-bg: #fff4de;
  --crit: #b42318;
  --crit-bg: #fdeceb;
  --unknown: #475467;
  --accent: #1d4ed8;
}

body.dark-theme {
  --bg: #111418;
  --surface: #191e24;
  --surface-2: #222932;
  --text: #eef2f7;
  --muted: #a4adba;
  --line: #303844;
  --ok-bg: #0f2b1c;
  --warn-bg: #332510;
  --crit-bg: #351716;
  --accent: #70a7ff;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  min-height: 100vh;
  background: var(--bg);
  color: var(--text);
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  letter-spacing: 0;
}

button,
input {
  font: inherit;
}

button {
  border: 0;
}

a {
  color: inherit;
  text-decoration: none;
}

.app-shell {
  width: min(1880px, 100%);
  margin: 0 auto;
  padding: 22px;
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 18px;
}

.topbar h1,
.login-heading h1 {
  margin: 3px 0 0;
  font-size: clamp(28px, 4vw, 46px);
  line-height: 1;
  letter-spacing: 0;
}

.eyebrow {
  display: block;
  color: var(--muted);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.top-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}

.updated {
  color: var(--muted);
  font-size: 13px;
  padding-right: 6px;
}

.icon-button,
.danger-button,
.primary-button {
  min-height: 38px;
  padding: 0 14px;
  border-radius: 6px;
  background: var(--surface);
  color: var(--text);
  border: 1px solid var(--line);
  cursor: pointer;
}

.icon-button:hover,
.primary-button:hover {
  border-color: var(--accent);
}

.danger-button {
  color: #ffffff;
  background: var(--crit);
  border-color: var(--crit);
}

.primary-button {
  width: 100%;
  color: #ffffff;
  background: var(--accent);
  border-color: var(--accent);
  font-weight: 800;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.metric-tile,
.section-block,
.login-panel {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
}

.metric-tile {
  min-height: 120px;
  padding: 16px;
}

.metric-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.metric-top span {
  color: var(--muted);
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
}

.metric-top strong {
  font-size: 30px;
  line-height: 1;
}

.metric-tile small {
  display: block;
  margin-top: 10px;
  color: var(--muted);
  line-height: 1.35;
}

.meter {
  height: 8px;
  margin-top: 16px;
  overflow: hidden;
  border-radius: 999px;
  background: var(--surface-2);
}

.meter span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--ok);
}

.metric-tile.warning .meter span,
.temp-card.warning strong {
  background: var(--warn);
  color: var(--warn);
}

.metric-tile.critical .meter span,
.temp-card.critical strong {
  background: var(--crit);
  color: var(--crit);
}

.metric-tile.unknown .meter span {
  background: var(--unknown);
}

.signal-strip {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
  margin: 14px 0 18px;
}

.signal-strip div {
  min-height: 70px;
  padding: 12px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--surface);
}

.signal-strip strong {
  display: block;
  font-size: 24px;
  line-height: 1;
}

.signal-strip span {
  display: block;
  margin-top: 7px;
  color: var(--muted);
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

.signal-strip .ok {
  background: var(--ok-bg);
}

.signal-strip .warning {
  background: var(--warn-bg);
}

.signal-strip .critical {
  background: var(--crit-bg);
}

.layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 430px;
  gap: 14px;
  align-items: start;
}

.main-column,
.side-column {
  display: grid;
  gap: 14px;
}

.section-block {
  padding: 14px;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.section-title h2 {
  margin: 0;
  font-size: 17px;
}

.section-title span {
  color: var(--muted);
  font-size: 13px;
}

.resource-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 10px;
}

.resource-card {
  min-height: 126px;
  padding: 12px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--surface-2);
  transition: border-color 0.15s, transform 0.15s;
}

.resource-link:hover .resource-card {
  border-color: var(--accent);
  transform: translateY(-1px);
}

.resource-card.stopped {
  opacity: 0.68;
}

.resource-head {
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr) auto;
  gap: 10px;
  align-items: start;
}

.service-mark {
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  border-radius: 8px;
  background: #0f172a;
  color: #ffffff;
  font-size: 13px;
  font-weight: 900;
}

body.dark-theme .service-mark {
  background: #d7e4ff;
  color: #0f172a;
}

.resource-card h3 {
  overflow: hidden;
  margin: 1px 0 5px;
  font-size: 15px;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.resource-card small {
  display: block;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.pill {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  color: var(--unknown);
  background: var(--surface);
  border: 1px solid var(--line);
  font-size: 11px;
  font-weight: 900;
}

.pill.running,
.pill.online {
  color: var(--ok);
  background: var(--ok-bg);
}

.pill.stopped,
.pill.critical {
  color: var(--crit);
  background: var(--crit-bg);
}

.mini-metrics {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  margin-top: 18px;
}

.mini-metrics span {
  padding: 7px 8px;
  border-radius: 6px;
  background: var(--surface);
  color: var(--muted);
  font-size: 12px;
  font-weight: 800;
  text-align: center;
}

.hardware-list,
.pool-list,
.disk-list,
.event-list {
  display: grid;
  gap: 8px;
}

.hardware-row,
.pool-row,
.disk-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 52px;
  padding: 10px;
  border-radius: 7px;
  background: var(--surface-2);
}

.hardware-row strong,
.pool-row strong,
.disk-row strong {
  display: block;
  font-size: 13px;
  line-height: 1.25;
}

.hardware-row small,
.pool-row small,
.disk-row small {
  display: block;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.hardware-row span,
.disk-row > span {
  flex-shrink: 0;
  color: var(--muted);
  font-size: 12px;
  font-weight: 900;
}

.hardware-row.subtle {
  align-items: flex-start;
}

.temp-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.temp-card {
  min-height: 94px;
  padding: 11px;
  border-radius: 7px;
  background: var(--surface-2);
  border: 1px solid var(--line);
}

.temp-card strong {
  display: block;
  margin-bottom: 6px;
  font-size: 20px;
  line-height: 1;
  color: var(--ok);
  background: transparent;
}

.temp-card span,
.temp-card small {
  display: block;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.pool-row.ok {
  background: var(--ok-bg);
}

.pool-row.critical {
  background: var(--crit-bg);
}

.disk-row .ok {
  color: var(--ok);
}

.disk-row .warning {
  color: var(--warn);
}

.disk-row .critical {
  color: var(--crit);
}

.event {
  max-height: 88px;
  overflow: auto;
  padding: 9px;
  border-left: 3px solid var(--line);
  border-radius: 6px;
  background: var(--surface-2);
  color: var(--muted);
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 11px;
  line-height: 1.4;
}

.event.warning {
  color: var(--warn);
  border-left-color: var(--warn);
  background: var(--warn-bg);
}

.event.critical {
  color: var(--crit);
  border-left-color: var(--crit);
  background: var(--crit-bg);
}

.loading {
  display: grid;
  place-items: center;
  min-height: 45vh;
  color: var(--muted);
}

.error {
  padding: 10px 12px;
  border-radius: 6px;
  color: var(--crit);
  background: var(--crit-bg);
}

.banner {
  margin-bottom: 12px;
}

.login-page {
  display: grid;
  place-items: center;
  min-height: 100vh;
  padding: 18px;
}

.login-panel {
  width: min(430px, 100%);
  padding: 22px;
}

.login-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 22px;
}

.login-panel form {
  display: grid;
  gap: 14px;
}

.login-panel label {
  display: grid;
  gap: 7px;
  color: var(--muted);
  font-size: 13px;
  font-weight: 800;
}

.login-panel input {
  width: 100%;
  height: 42px;
  border: 1px solid var(--line);
  border-radius: 6px;
  padding: 0 11px;
  color: var(--text);
  background: var(--surface-2);
}

@media (max-width: 1180px) {
  .layout {
    grid-template-columns: 1fr;
  }

  .side-column {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 820px) {
  .app-shell {
    padding: 14px;
  }

  .topbar,
  .section-title {
    align-items: flex-start;
    flex-direction: column;
  }

  .top-actions {
    justify-content: flex-start;
  }

  .summary-grid,
  .signal-strip,
  .side-column {
    grid-template-columns: 1fr 1fr;
  }

  .resource-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 540px) {
  .summary-grid,
  .signal-strip,
  .side-column,
  .temp-grid {
    grid-template-columns: 1fr;
  }

  .resource-head {
    grid-template-columns: 42px minmax(0, 1fr);
  }

  .resource-head .pill {
    grid-column: 1 / -1;
    width: fit-content;
  }
}

@media (min-width: 821px) {
  body {
    overflow: hidden;
  }

  .app-shell {
    height: 100dvh;
    display: grid;
    grid-template-rows: auto auto auto minmax(0, 1fr);
    gap: 10px;
    padding: 14px;
    overflow: hidden;
  }

  .topbar {
    margin-bottom: 0;
  }

  .topbar h1 {
    font-size: clamp(24px, 3vw, 36px);
  }

  .summary-grid {
    gap: 10px;
  }

  .metric-tile {
    min-height: 88px;
    padding: 12px;
  }

  .metric-top strong {
    font-size: 24px;
  }

  .metric-tile small {
    margin-top: 7px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .meter {
    margin-top: 10px;
  }

  .signal-strip {
    gap: 8px;
    margin: 0;
  }

  .signal-strip div {
    min-height: 52px;
    padding: 9px 10px;
  }

  .signal-strip strong,
  .signal-strip span {
    display: inline-block;
  }

  .signal-strip strong {
    font-size: 21px;
  }

  .signal-strip span {
    margin-top: 0;
    margin-left: 7px;
  }

  .layout {
    grid-template-columns: minmax(520px, 1fr) minmax(360px, 0.72fr);
    gap: 10px;
    min-height: 0;
    overflow: hidden;
  }

  .main-column,
  .side-column {
    min-height: 0;
    height: 100%;
    gap: 10px;
    overflow: auto;
    padding-right: 3px;
    scrollbar-width: thin;
  }

  .side-column {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto minmax(140px, 1fr);
  }

  .section-block {
    min-height: 0;
    padding: 10px;
  }

  .section-title {
    margin-bottom: 9px;
  }

  .section-title h2 {
    font-size: 15px;
  }

  .resource-grid {
    grid-template-columns: repeat(auto-fill, minmax(205px, 1fr));
    gap: 8px;
  }

  .resource-card {
    min-height: 94px;
    padding: 9px;
  }

  .resource-head {
    grid-template-columns: 34px minmax(0, 1fr) auto;
    gap: 8px;
  }

  .service-mark {
    width: 32px;
    height: 32px;
    border-radius: 7px;
    font-size: 11px;
  }

  .resource-card h3 {
    font-size: 13px;
  }

  .resource-card small {
    font-size: 11px;
  }

  .pill {
    min-height: 21px;
    padding: 0 7px;
    font-size: 10px;
  }

  .mini-metrics {
    gap: 5px;
    margin-top: 10px;
  }

  .mini-metrics span {
    padding: 5px 6px;
    font-size: 11px;
  }

  .hardware-list,
  .pool-list,
  .disk-list,
  .event-list {
    gap: 6px;
  }

  .hardware-row,
  .pool-row,
  .disk-row {
    min-height: 42px;
    padding: 8px;
  }

  .hardware-row strong,
  .pool-row strong,
  .disk-row strong {
    font-size: 12px;
  }

  .hardware-row small,
  .pool-row small,
  .disk-row small,
  .hardware-row span,
  .disk-row > span {
    font-size: 11px;
  }

  .temp-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px;
  }

  .temp-card {
    min-height: 72px;
    padding: 8px;
  }

  .temp-card strong {
    margin-bottom: 5px;
    font-size: 17px;
  }

  .temp-card span,
  .temp-card small {
    font-size: 11px;
  }

  .event {
    max-height: 68px;
    padding: 7px;
    font-size: 10.5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,uGAAuG;EACvG,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,iCAAiC;EACjC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;;EAGE,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,0BAA0B;EAC1B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;EACb,QAAQ;AACV;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;EAGE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,qEAAqE;EACrE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;;IAGE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,iDAAiD;IACjD,SAAS;IACT,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,+DAA+D;IAC/D,SAAS;IACT,aAAa;IACb,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;IACb,YAAY;IACZ,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,qDAAqD;EACvD;;EAEA;IACE,aAAa;IACb,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4DAA4D;IAC5D,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,+CAA+C;IAC/C,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;;;IAIE,QAAQ;EACV;;EAEA;;;IAGE,gBAAgB;IAChB,YAAY;EACd;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;;;;;IAKE,eAAe;EACjB;;EAEA;IACE,gDAAgD;IAChD,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":[":root {\n  --bg: #f3f5f8;\n  --surface: #ffffff;\n  --surface-2: #eef2f6;\n  --text: #17202a;\n  --muted: #667085;\n  --line: #d9e0e8;\n  --ok: #15803d;\n  --ok-bg: #e8f7ef;\n  --warn: #b45309;\n  --warn-bg: #fff4de;\n  --crit: #b42318;\n  --crit-bg: #fdeceb;\n  --unknown: #475467;\n  --accent: #1d4ed8;\n}\n\nbody.dark-theme {\n  --bg: #111418;\n  --surface: #191e24;\n  --surface-2: #222932;\n  --text: #eef2f7;\n  --muted: #a4adba;\n  --line: #303844;\n  --ok-bg: #0f2b1c;\n  --warn-bg: #332510;\n  --crit-bg: #351716;\n  --accent: #70a7ff;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  min-height: 100vh;\n  background: var(--bg);\n  color: var(--text);\n  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  letter-spacing: 0;\n}\n\nbutton,\ninput {\n  font: inherit;\n}\n\nbutton {\n  border: 0;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\n.app-shell {\n  width: min(1880px, 100%);\n  margin: 0 auto;\n  padding: 22px;\n}\n\n.topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 18px;\n}\n\n.topbar h1,\n.login-heading h1 {\n  margin: 3px 0 0;\n  font-size: clamp(28px, 4vw, 46px);\n  line-height: 1;\n  letter-spacing: 0;\n}\n\n.eyebrow {\n  display: block;\n  color: var(--muted);\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0;\n  text-transform: uppercase;\n}\n\n.top-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.updated {\n  color: var(--muted);\n  font-size: 13px;\n  padding-right: 6px;\n}\n\n.icon-button,\n.danger-button,\n.primary-button {\n  min-height: 38px;\n  padding: 0 14px;\n  border-radius: 6px;\n  background: var(--surface);\n  color: var(--text);\n  border: 1px solid var(--line);\n  cursor: pointer;\n}\n\n.icon-button:hover,\n.primary-button:hover {\n  border-color: var(--accent);\n}\n\n.danger-button {\n  color: #ffffff;\n  background: var(--crit);\n  border-color: var(--crit);\n}\n\n.primary-button {\n  width: 100%;\n  color: #ffffff;\n  background: var(--accent);\n  border-color: var(--accent);\n  font-weight: 800;\n}\n\n.summary-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.metric-tile,\n.section-block,\n.login-panel {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);\n}\n\n.metric-tile {\n  min-height: 120px;\n  padding: 16px;\n}\n\n.metric-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.metric-top span {\n  color: var(--muted);\n  font-size: 13px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.metric-top strong {\n  font-size: 30px;\n  line-height: 1;\n}\n\n.metric-tile small {\n  display: block;\n  margin-top: 10px;\n  color: var(--muted);\n  line-height: 1.35;\n}\n\n.meter {\n  height: 8px;\n  margin-top: 16px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: var(--surface-2);\n}\n\n.meter span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: var(--ok);\n}\n\n.metric-tile.warning .meter span,\n.temp-card.warning strong {\n  background: var(--warn);\n  color: var(--warn);\n}\n\n.metric-tile.critical .meter span,\n.temp-card.critical strong {\n  background: var(--crit);\n  color: var(--crit);\n}\n\n.metric-tile.unknown .meter span {\n  background: var(--unknown);\n}\n\n.signal-strip {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 10px;\n  margin: 14px 0 18px;\n}\n\n.signal-strip div {\n  min-height: 70px;\n  padding: 12px;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  background: var(--surface);\n}\n\n.signal-strip strong {\n  display: block;\n  font-size: 24px;\n  line-height: 1;\n}\n\n.signal-strip span {\n  display: block;\n  margin-top: 7px;\n  color: var(--muted);\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.signal-strip .ok {\n  background: var(--ok-bg);\n}\n\n.signal-strip .warning {\n  background: var(--warn-bg);\n}\n\n.signal-strip .critical {\n  background: var(--crit-bg);\n}\n\n.layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 430px;\n  gap: 14px;\n  align-items: start;\n}\n\n.main-column,\n.side-column {\n  display: grid;\n  gap: 14px;\n}\n\n.section-block {\n  padding: 14px;\n}\n\n.section-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.section-title h2 {\n  margin: 0;\n  font-size: 17px;\n}\n\n.section-title span {\n  color: var(--muted);\n  font-size: 13px;\n}\n\n.resource-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 10px;\n}\n\n.resource-card {\n  min-height: 126px;\n  padding: 12px;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  background: var(--surface-2);\n  transition: border-color 0.15s, transform 0.15s;\n}\n\n.resource-link:hover .resource-card {\n  border-color: var(--accent);\n  transform: translateY(-1px);\n}\n\n.resource-card.stopped {\n  opacity: 0.68;\n}\n\n.resource-head {\n  display: grid;\n  grid-template-columns: 46px minmax(0, 1fr) auto;\n  gap: 10px;\n  align-items: start;\n}\n\n.service-mark {\n  display: grid;\n  place-items: center;\n  width: 42px;\n  height: 42px;\n  border-radius: 8px;\n  background: #0f172a;\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 900;\n}\n\nbody.dark-theme .service-mark {\n  background: #d7e4ff;\n  color: #0f172a;\n}\n\n.resource-card h3 {\n  overflow: hidden;\n  margin: 1px 0 5px;\n  font-size: 15px;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.resource-card small {\n  display: block;\n  color: var(--muted);\n  font-size: 12px;\n  line-height: 1.35;\n  overflow-wrap: anywhere;\n}\n\n.pill {\n  display: inline-flex;\n  align-items: center;\n  min-height: 24px;\n  padding: 0 8px;\n  border-radius: 999px;\n  color: var(--unknown);\n  background: var(--surface);\n  border: 1px solid var(--line);\n  font-size: 11px;\n  font-weight: 900;\n}\n\n.pill.running,\n.pill.online {\n  color: var(--ok);\n  background: var(--ok-bg);\n}\n\n.pill.stopped,\n.pill.critical {\n  color: var(--crit);\n  background: var(--crit-bg);\n}\n\n.mini-metrics {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 6px;\n  margin-top: 18px;\n}\n\n.mini-metrics span {\n  padding: 7px 8px;\n  border-radius: 6px;\n  background: var(--surface);\n  color: var(--muted);\n  font-size: 12px;\n  font-weight: 800;\n  text-align: center;\n}\n\n.hardware-list,\n.pool-list,\n.disk-list,\n.event-list {\n  display: grid;\n  gap: 8px;\n}\n\n.hardware-row,\n.pool-row,\n.disk-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  min-height: 52px;\n  padding: 10px;\n  border-radius: 7px;\n  background: var(--surface-2);\n}\n\n.hardware-row strong,\n.pool-row strong,\n.disk-row strong {\n  display: block;\n  font-size: 13px;\n  line-height: 1.25;\n}\n\n.hardware-row small,\n.pool-row small,\n.disk-row small {\n  display: block;\n  color: var(--muted);\n  font-size: 12px;\n  line-height: 1.35;\n  overflow-wrap: anywhere;\n}\n\n.hardware-row span,\n.disk-row > span {\n  flex-shrink: 0;\n  color: var(--muted);\n  font-size: 12px;\n  font-weight: 900;\n}\n\n.hardware-row.subtle {\n  align-items: flex-start;\n}\n\n.temp-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.temp-card {\n  min-height: 94px;\n  padding: 11px;\n  border-radius: 7px;\n  background: var(--surface-2);\n  border: 1px solid var(--line);\n}\n\n.temp-card strong {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 20px;\n  line-height: 1;\n  color: var(--ok);\n  background: transparent;\n}\n\n.temp-card span,\n.temp-card small {\n  display: block;\n  color: var(--muted);\n  font-size: 12px;\n  line-height: 1.25;\n  overflow-wrap: anywhere;\n}\n\n.pool-row.ok {\n  background: var(--ok-bg);\n}\n\n.pool-row.critical {\n  background: var(--crit-bg);\n}\n\n.disk-row .ok {\n  color: var(--ok);\n}\n\n.disk-row .warning {\n  color: var(--warn);\n}\n\n.disk-row .critical {\n  color: var(--crit);\n}\n\n.event {\n  max-height: 88px;\n  overflow: auto;\n  padding: 9px;\n  border-left: 3px solid var(--line);\n  border-radius: 6px;\n  background: var(--surface-2);\n  color: var(--muted);\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 11px;\n  line-height: 1.4;\n}\n\n.event.warning {\n  color: var(--warn);\n  border-left-color: var(--warn);\n  background: var(--warn-bg);\n}\n\n.event.critical {\n  color: var(--crit);\n  border-left-color: var(--crit);\n  background: var(--crit-bg);\n}\n\n.loading {\n  display: grid;\n  place-items: center;\n  min-height: 45vh;\n  color: var(--muted);\n}\n\n.error {\n  padding: 10px 12px;\n  border-radius: 6px;\n  color: var(--crit);\n  background: var(--crit-bg);\n}\n\n.banner {\n  margin-bottom: 12px;\n}\n\n.login-page {\n  display: grid;\n  place-items: center;\n  min-height: 100vh;\n  padding: 18px;\n}\n\n.login-panel {\n  width: min(430px, 100%);\n  padding: 22px;\n}\n\n.login-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 22px;\n}\n\n.login-panel form {\n  display: grid;\n  gap: 14px;\n}\n\n.login-panel label {\n  display: grid;\n  gap: 7px;\n  color: var(--muted);\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.login-panel input {\n  width: 100%;\n  height: 42px;\n  border: 1px solid var(--line);\n  border-radius: 6px;\n  padding: 0 11px;\n  color: var(--text);\n  background: var(--surface-2);\n}\n\n@media (max-width: 1180px) {\n  .layout {\n    grid-template-columns: 1fr;\n  }\n\n  .side-column {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 820px) {\n  .app-shell {\n    padding: 14px;\n  }\n\n  .topbar,\n  .section-title {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .top-actions {\n    justify-content: flex-start;\n  }\n\n  .summary-grid,\n  .signal-strip,\n  .side-column {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .resource-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 540px) {\n  .summary-grid,\n  .signal-strip,\n  .side-column,\n  .temp-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .resource-head {\n    grid-template-columns: 42px minmax(0, 1fr);\n  }\n\n  .resource-head .pill {\n    grid-column: 1 / -1;\n    width: fit-content;\n  }\n}\n\n@media (min-width: 821px) {\n  body {\n    overflow: hidden;\n  }\n\n  .app-shell {\n    height: 100dvh;\n    display: grid;\n    grid-template-rows: auto auto auto minmax(0, 1fr);\n    gap: 10px;\n    padding: 14px;\n    overflow: hidden;\n  }\n\n  .topbar {\n    margin-bottom: 0;\n  }\n\n  .topbar h1 {\n    font-size: clamp(24px, 3vw, 36px);\n  }\n\n  .summary-grid {\n    gap: 10px;\n  }\n\n  .metric-tile {\n    min-height: 88px;\n    padding: 12px;\n  }\n\n  .metric-top strong {\n    font-size: 24px;\n  }\n\n  .metric-tile small {\n    margin-top: 7px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .meter {\n    margin-top: 10px;\n  }\n\n  .signal-strip {\n    gap: 8px;\n    margin: 0;\n  }\n\n  .signal-strip div {\n    min-height: 52px;\n    padding: 9px 10px;\n  }\n\n  .signal-strip strong,\n  .signal-strip span {\n    display: inline-block;\n  }\n\n  .signal-strip strong {\n    font-size: 21px;\n  }\n\n  .signal-strip span {\n    margin-top: 0;\n    margin-left: 7px;\n  }\n\n  .layout {\n    grid-template-columns: minmax(520px, 1fr) minmax(360px, 0.72fr);\n    gap: 10px;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .main-column,\n  .side-column {\n    min-height: 0;\n    height: 100%;\n    gap: 10px;\n    overflow: auto;\n    padding-right: 3px;\n    scrollbar-width: thin;\n  }\n\n  .side-column {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto auto minmax(140px, 1fr);\n  }\n\n  .section-block {\n    min-height: 0;\n    padding: 10px;\n  }\n\n  .section-title {\n    margin-bottom: 9px;\n  }\n\n  .section-title h2 {\n    font-size: 15px;\n  }\n\n  .resource-grid {\n    grid-template-columns: repeat(auto-fill, minmax(205px, 1fr));\n    gap: 8px;\n  }\n\n  .resource-card {\n    min-height: 94px;\n    padding: 9px;\n  }\n\n  .resource-head {\n    grid-template-columns: 34px minmax(0, 1fr) auto;\n    gap: 8px;\n  }\n\n  .service-mark {\n    width: 32px;\n    height: 32px;\n    border-radius: 7px;\n    font-size: 11px;\n  }\n\n  .resource-card h3 {\n    font-size: 13px;\n  }\n\n  .resource-card small {\n    font-size: 11px;\n  }\n\n  .pill {\n    min-height: 21px;\n    padding: 0 7px;\n    font-size: 10px;\n  }\n\n  .mini-metrics {\n    gap: 5px;\n    margin-top: 10px;\n  }\n\n  .mini-metrics span {\n    padding: 5px 6px;\n    font-size: 11px;\n  }\n\n  .hardware-list,\n  .pool-list,\n  .disk-list,\n  .event-list {\n    gap: 6px;\n  }\n\n  .hardware-row,\n  .pool-row,\n  .disk-row {\n    min-height: 42px;\n    padding: 8px;\n  }\n\n  .hardware-row strong,\n  .pool-row strong,\n  .disk-row strong {\n    font-size: 12px;\n  }\n\n  .hardware-row small,\n  .pool-row small,\n  .disk-row small,\n  .hardware-row span,\n  .disk-row > span {\n    font-size: 11px;\n  }\n\n  .temp-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 6px;\n  }\n\n  .temp-card {\n    min-height: 72px;\n    padding: 8px;\n  }\n\n  .temp-card strong {\n    margin-bottom: 5px;\n    font-size: 17px;\n  }\n\n  .temp-card span,\n  .temp-card small {\n    font-size: 11px;\n  }\n\n  .event {\n    max-height: 68px;\n    padding: 7px;\n    font-size: 10.5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
